import axios from "axios";
import { getCognitoIdToken } from "@/lib/tokenStore";
import { isCognitoConfigured } from "@/lib/cognitoPool";
import { API_KEY } from "@/lib/env";

axios.interceptors.request.use((config) => {
  const token = getCognitoIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// /api/* (integrations) still use x-api-key; SPA only calls /backend/* with Cognito JWT.
if (API_KEY) {
  axios.defaults.headers.common["x-api-key"] = API_KEY;
}

if (
  process.env.NODE_ENV === "development" &&
  !isCognitoConfigured &&
  !API_KEY
) {
  console.warn(
    "[halo] Set REACT_APP_COGNITO_USER_POOL_ID + REACT_APP_COGNITO_CLIENT_ID (or REACT_APP_API_KEY for legacy /backend).",
  );
}
